import { PayloadAction } from '@reduxjs/toolkit';

import { EditorState } from 'editor/src/store/editor/types';

const setSelectedElementUuidsReducer = (state: EditorState, action: PayloadAction<number[]>) => {
  state.selectedElementUuids = action.payload;
};

export default setSelectedElementUuidsReducer;
